import styles from "./Sticker.module.css";
import logoUrl from "../../assets/images/logo.png";

const StickerTemplate = ({ sticker = {} , onPrint }) => {
  const {
    box_no = "01/01",
    sales_order = "0000000000",
    quantity = "0",
    customer_name = "Customer Name",
  } = sticker || {};

  return (
    <div className={styles.stickerContainer}>
      <button className={`btn btn-primary ${styles.actions}`} onClick={() => onPrint && onPrint(sticker)}>Print</button>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          {logoUrl ? (
            <img src={logoUrl} alt="logo" className={styles.logo} />
          ) : (
            <div className={styles.brandText}>TEMPSENS</div>
          )}
        </div>

        <div className={styles.spacer} />

        <div className={styles.row}>
          <div className={styles.label}>JOB NO.</div>
          <div className={styles.value}>{sales_order}</div>
        </div>

        <div className={styles.row}>
          <div className={styles.label}>QUANTITY</div>
          <div className={styles.value}>{quantity} NOS</div>
        </div>

        <div className={styles.row}>
          <div className={styles.label}>BOX NO.</div>
          <div className={styles.value}>{box_no}</div>
        </div>

        <div className={styles.row}>
          <div className={styles.label}>CUSTOMER</div>
          <div className={styles.value}>{sticker.customer_name}</div>
        </div>
      </div>
    </div>
  );
};

export default StickerTemplate;
